// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__GJHAo","footer":"ModalError_footer__1rfm8"};